import { FeatureFlagKey } from '../../feature-flags/feature-flag-key';

export enum PickerType {
  Upload = 'Upload',
  Clarity = 'Clarity',
  Connect = 'Connect',
  GoogleDrive = 'GoogleDrive',
  OneDrive = 'OneDrive',
  Dropbox = 'Dropbox',
}

export const FILE_PICKERS_CONFIG: FilePickerConfig[] = [
  { pickerType: PickerType.Upload, featureFlagKey: 'tools_import.upload', icon: '' },
  {
    pickerType: PickerType.Clarity,
    featureFlagKey: 'tools_import.clarity',
    icon: 'clarity',
    name: 'Clarity',
  },
  {
    pickerType: PickerType.Connect,
    featureFlagKey: 'tools_import.connect',
    icon: 'connect',
    name: 'Connect',
  },
  {
    pickerType: PickerType.GoogleDrive,
    featureFlagKey: 'tools_import.googleDrive',
    icon: 'google-drive',
    name: 'Google Drive',
  },
  {
    pickerType: PickerType.OneDrive,
    featureFlagKey: 'tools_import.oneDrive',
    icon: 'one-drive',
    name: 'OneDrive',
  },
  {
    pickerType: PickerType.Dropbox,
    featureFlagKey: 'tools_import.dropbox',
    icon: 'dropbox',
    name: 'Dropbox',
  },
];

export interface FilePickerConfig {
  pickerType: PickerType;
  featureFlagKey: FeatureFlagKey;
  icon: string;
  name?: string;
}

export interface FilePicker extends FilePickerConfig {
  enabled: boolean;
}
